import axios from "axios";

import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

const token = cookies.get("token");
const baseURL = process.env.VUE_APP_DOMAIN;

axios.defaults.baseURL = baseURL;
axios.defaults.headers.common["Content-Type"] = "application/json";

axios.interceptors.request.use(
  (config) => {
    let newConfig = { ...config };

    // Intercept, so that auth endpoints are not using Bearer token
    if (
      !newConfig.url.includes("auth") &&
      !newConfig.url.includes("passreset")
    ) {
      const token = cookies.get("token") || null;
      newConfig.headers.Authorization = `Bearer ${token}`;
    } else {
      delete newConfig.headers.Authorization;
    }

    return newConfig;
  },
  (err) => Promise.reject(err)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status, data } = error.response;
    if (status === 500) {
      // show error notification
    }

    if (status === 401) {
      if (
        data.errors[0].errorCode === "token.expired" ||
        data.errors[0].errorCode === "token.invalid"
      ) {
        cookies.remove("token");
        cookies.remove("refreshToken");
        if (!window.location.pathname.includes("login"))
          window.location.href = "/web/login";
      }
    }

    // if (status === 403 || status === 406) {

    // }

    return Promise.reject(error);
  }
);
